import { useTranslation } from 'react-i18next';

type tActiveFilterBadgeProps = {
  count: number;
  compact?: boolean;
};

export default function ActiveFilterBadge(props: tActiveFilterBadgeProps) {
  const { t } = useTranslation('navbar/navbar');

  if (props.count === 0) return null;

  return (
    <span
      className={`badge text-xs bg-green-50 text-green-700 ${props.compact ? 'badge-sm' : ''}`}
    >
      {props.compact
        ? props.count
        : t('filters.activeCount', { count: props.count })}
    </span>
  );
}
